import React from 'react';
import InfoTooltip from '../../common/InfoTooltip';

const BrushSizeSection = ({ 
    activeButton, 
    setActiveButton, 
    brushSize, 
    eraserSize, 
    inputValue, 
    setInputValue, 
    setBrushSize, 
    setEraserSize, 
    showAreaInfo, 
    setShowAreaInfo 
}) => {
    return (
        <div className="section" style={{ marginBottom: 0 }}>
            <div className="area-header">
                <div className="flex items-center gap-2">
                    <label className="block text-gray-700 font-semibold text-xs tracking-wide">Brush Size</label>              
                </div>
                <div className="icon-buttons">
                    <div style={{ display: 'inline-block', position: 'relative' }}>
                        <button
                            onClick={() => { setActiveButton('pen'); setInputValue(brushSize); }}
                            className={activeButton === 'pen' ? 'selected' : ''}
                            style={{ position: 'relative' }}
                            onMouseEnter={e => {
                                const tooltip = e.currentTarget.querySelector('.tooltip');
                                if (tooltip) tooltip.style.opacity = 1;
                            }}
                            onMouseLeave={e => {
                                const tooltip = e.currentTarget.querySelector('.tooltip');
                                if (tooltip) tooltip.style.opacity = 0;
                            }}
                        >
                            <i className="fas fa-pen" />
                            <span
                                className="tooltip"
                                style={{
                                    position: 'absolute',
                                    bottom: '-28px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    background: '#222',
                                    color: '#fff',
                                    padding: '2px 8px',
                                    borderRadius: 4,
                                    fontSize: 11,
                                    whiteSpace: 'nowrap',
                                    opacity: 0,
                                    pointerEvents: 'none',
                                    transition: 'opacity 0.2s'
                                }}
                            >
                                Brush
                            </span>
                        </button>
                    </div>
                    <div style={{ display: 'inline-block', position: 'relative' }}>
                        <button
                            onClick={() => { setActiveButton('eraser'); setInputValue(eraserSize); }}
                            className={activeButton === 'eraser' ? 'selected' : ''}
                            style={{ position: 'relative' }}
                            onMouseEnter={e => {
                                const tooltip = e.currentTarget.querySelector('.tooltip');
                                if (tooltip) tooltip.style.opacity = 1;
                            }}
                            onMouseLeave={e => {
                                const tooltip = e.currentTarget.querySelector('.tooltip');
                                if (tooltip) tooltip.style.opacity = 0;
                            }}
                        >
                            <i className="fas fa-eraser" />
                            <span
                                className="tooltip"
                                style={{
                                    position: 'absolute',
                                    bottom: '-28px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    background: '#222',
                                    color: '#fff',
                                    padding: '2px 8px',
                                    borderRadius: 4,
                                    fontSize: 11,
                                    whiteSpace: 'nowrap',
                                    opacity: 0,
                                    pointerEvents: 'none',
                                    transition: 'opacity 0.2s'
                                }}
                            >
                                Eraser
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="area-controls">
                <input
                    type="range"
                    min="0"
                    max="50"
                    value={inputValue}
                    onChange={(e) => {
                        setInputValue(parseInt(e.target.value));
                        if (activeButton === 'pen') {
                            setBrushSize(parseInt(e.target.value));
                        } else {
                            setEraserSize(parseInt(e.target.value));
                        }
                    }}
                />
                <div className="icon-buttons" style={{ width: "50px", height: "60px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button style={{ width: `${inputValue}px`, height: `${inputValue}px`, backgroundColor: '#c9c2fa' }}></button>
                </div>
            </div>
        </div>
    );
};

export default BrushSizeSection; 